<template>
  <div>
    <!-- 选择地图导航 -->
    <van-action-sheet
      v-model="showSheet"
      :actions="actions"
      cancel-text="取消"
      close-on-click-action
      @select="onSelect"
      @cancel="close"
    />
  </div>
</template>

<script>
export default {
  data() {
    return {
      showSheet: false,
      actions: [{ name: '高德地图', value: 'gd' }, { name: '百度地图', value: 'bd' }, { name: '腾讯地图', value: 'qq' }],
      partnerAddress: '',
      lng: '',
      lat: ''
    };
  },
  created() {
  },
  mounted() {
  },
  methods: {
    open(partnerAddress, lng, lat) {
      this.partnerAddress = partnerAddress;
      this.lng = lng;
      this.lat = lat;
      this.showSheet = true;
    },
    close() {
      this.showSheet = false;
    },
    onSelect(item) {
      this.close();
      this.guide(item.value);
    },
    // 导航
    guide(signMap) {
      const self = this;
      if (self.partnerAddress && self.partnerAddress !== '') {
        // 地址partnerAddress 经纬度lng lat
        const lng = self.lng;
        const lat = self.lat;
        // 调起地图app
        let url1 = '';
        // 访问地图h5
        let url2 = '';
        if (signMap === 'gd') {
          // 高德地图
          if (self.customBrowserVersion().android) {
            url1 = `androidamap://viewMap?poiname=${self.partnerAddress}&lat=${lat}&lon=${lng}&dev=0`;
          } else if (self.customBrowserVersion().ios) {
            url1 = `iosamap://viewMap?poiname=${self.partnerAddress}&lat=${lat}&lon=${lng}&dev=0`;
          }
          url2 = `https://uri.amap.com/marker?position=${lng},${lat}&name=${self.partnerAddress}`;
        } else if (signMap === 'bd') {
          // 百度地图
          if (self.customBrowserVersion().android) {
            // 安卓操作系统
            url1 = `baidumap://map/marker?location=${lat},${lng}&title=${self.partnerAddress}&content=${self.partnerAddress}&coord_type=gcj02&traffic=on&src=andr.baidu.openAPIdemo`;
          } else if (self.customBrowserVersion().ios) {
            // ios操作系统
            url1 = `baidumap://map/marker?location=${lat},${lng}&title=${self.partnerAddress}&content=${self.partnerAddress}&coord_type=gcj02&src=ios.baidu.openAPIdemo`;
          }
          url2 = `http://api.map.baidu.com/marker?location=${lat},${lng}&title=${self.partnerAddress}&output=html&coord_type=gcj02&src=webapp.baidu.openAPIdemo`;
        } else if (signMap === 'qq') {
          // 腾讯地图
          url1 = `qqmap://map/marker?marker=coord:${lat},${lng};title:${self.partnerAddress}`;
          url2 = `http://apis.map.qq.com/uri/v1/marker?marker=coord:${lat},${lng};title:${self.partnerAddress}`;
        }
        const d = new Date();
        const t0 = d.getTime();
        window.location.href = url1;
        // 由于打开需要1～2秒，利用这个时间差来处理－－打开app后，返回h5页面会出现页面变成app下载页面，影响用户体验
        var delay = setInterval(function() {
          var d = new Date();
          var t1 = d.getTime();
          if (t1 - t0 < 3000 && t1 - t0 > 2000) {
            const hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||
              window.document.webkitHidden;
            if (typeof hidden === 'undefined' || hidden === false) {
              window.location.href = url2;
            }
          }
          if (t1 - t0 >= 3000) {
            clearInterval(delay);
          }
        }, 1000);
      }
    },
    // 区分设备
    customBrowserVersion() {
      var u = navigator.userAgent;
      return {
        trident: u.indexOf('Trident') > -1, // IE内核
        presto: u.indexOf('Presto') > -1, // opera内核
        webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, // 火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), // 是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), // ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, // android终端
        iPhone: u.indexOf('iPhone') > -1, // 是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, // 是否iPad
        webApp: u.indexOf('Safari') === -1, // 是否web应用程序，没有头部与底部
        weixin: u.indexOf('MicroMessenger') > -1, // 是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) === ' qq', // 是否QQ
        isBaidu: u.indexOf('baiduboxapp') !== -1, // 是否为百度浏览器
        isqqBrowser: u.indexOf('mqqbrowser') !== -1, // 是否为qq浏览器
        isWxBrowser: u.indexOf('micromessenger') !== -1, // 是否为微信浏览器
        isUc: u.indexOf('ucbrowser') !== -1 // 是否为uc浏览器
      };
    }

  }
};
</script>

<style lang="scss" scoped>

</style>
